exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#EnteteProvisionRisque .el-form-item__error {\n  position: initial!important\n}\n", ""]);

// exports
